/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { FileImportReportDto } from '../models';
// @ts-ignore
import type { PptxImportContentDto } from '../models';
// @ts-ignore
import type { PptxImportDraftDto } from '../models';
// @ts-ignore
import type { PptxImportSummaryDto } from '../models';
// @ts-ignore
import type { PptxSlidePreviewsDto } from '../models';
/**
 * RestPptxImportsApi - axios parameter creator
 */
export const RestPptxImportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an import draft
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePptxImport: async (draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('deletePptxImport', 'draftId', draftId)
            const localVarPath = `/api/pptx-imports/{draftId}`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the draft as the import workbook (Dania / Zestawy / Struktura)
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPptxImportWorkbook: async (draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('downloadPptxImportWorkbook', 'draftId', draftId)
            const localVarPath = `/api/pptx-imports/{draftId}/workbook`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read the deck again, replacing the draft content
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractPptxImportAgain: async (draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('extractPptxImportAgain', 'draftId', draftId)
            const localVarPath = `/api/pptx-imports/{draftId}/extract`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an import draft with its slides and editable content
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPptxImport: async (draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('getPptxImport', 'draftId', draftId)
            const localVarPath = `/api/pptx-imports/{draftId}`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List catalogue import drafts read from offer decks, newest first
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPptxImports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pptx-imports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the rendered image of one deck slide
         * @param {string} draftId 
         * @param {number} slideNumber 
         * @param {string} [version] The slide preview version; it only makes the URL unique per rendering, so browsers never reuse an image cached for an older rendering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPptxSlideImage: async (draftId: string, slideNumber: number, version?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('getPptxSlideImage', 'draftId', draftId)
            // verify required parameter 'slideNumber' is not null or undefined
            assertParamExists('getPptxSlideImage', 'slideNumber', slideNumber)
            const localVarPath = `/api/pptx-imports/{draftId}/slides/{slideNumber}/image`
                .replace('{draftId}', encodeURIComponent(String(draftId)))
                .replace('{slideNumber}', encodeURIComponent(String(slideNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            localVarHeaderParameter['Accept'] = 'image/jpeg';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Slides are rendered in the background after the upload. While that runs the status is RENDERING and the list is empty; a draft uploaded before previews existed starts rendering on the first call. 
         * @summary Get the rendered previews of the deck slides with the position of every text line
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPptxSlidePreviews: async (draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('getPptxSlidePreviews', 'draftId', draftId)
            const localVarPath = `/api/pptx-imports/{draftId}/slide-previews`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Runs the same importer as the dish import screen and records the generated workbook in its history.
         * @summary Import the draft into the catalogue (new dishes and group sets)
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPptxImport: async (draftId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('importPptxImport', 'draftId', draftId)
            const localVarPath = `/api/pptx-imports/{draftId}/import`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dishes whose name matches a catalogue dish exactly are linked to it on save.
         * @summary Save the edited content of an import draft
         * @param {string} draftId 
         * @param {PptxImportContentDto} pptxImportContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePptxImport: async (draftId: string, pptxImportContentDto: PptxImportContentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'draftId' is not null or undefined
            assertParamExists('savePptxImport', 'draftId', draftId)
            // verify required parameter 'pptxImportContentDto' is not null or undefined
            assertParamExists('savePptxImport', 'pptxImportContentDto', pptxImportContentDto)
            const localVarPath = `/api/pptx-imports/{draftId}`
                .replace('{draftId}', encodeURIComponent(String(draftId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pptxImportContentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an offer deck (PPTX) and start reading dishes and group sets from it
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPptxImport: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadPptxImport', 'file', file)
            const localVarPath = `/api/pptx-imports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestPptxImportsApi - functional programming interface
 */
export const RestPptxImportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestPptxImportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an import draft
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePptxImport(draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePptxImport(draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.deletePptxImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download the draft as the import workbook (Dania / Zestawy / Struktura)
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPptxImportWorkbook(draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPptxImportWorkbook(draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.downloadPptxImportWorkbook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read the deck again, replacing the draft content
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractPptxImportAgain(draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PptxImportDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractPptxImportAgain(draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.extractPptxImportAgain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an import draft with its slides and editable content
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPptxImport(draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PptxImportDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPptxImport(draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.getPptxImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List catalogue import drafts read from offer decks, newest first
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPptxImports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PptxImportSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPptxImports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.getPptxImports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the rendered image of one deck slide
         * @param {string} draftId 
         * @param {number} slideNumber 
         * @param {string} [version] The slide preview version; it only makes the URL unique per rendering, so browsers never reuse an image cached for an older rendering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPptxSlideImage(draftId: string, slideNumber: number, version?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPptxSlideImage(draftId, slideNumber, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.getPptxSlideImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Slides are rendered in the background after the upload. While that runs the status is RENDERING and the list is empty; a draft uploaded before previews existed starts rendering on the first call. 
         * @summary Get the rendered previews of the deck slides with the position of every text line
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPptxSlidePreviews(draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PptxSlidePreviewsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPptxSlidePreviews(draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.getPptxSlidePreviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Runs the same importer as the dish import screen and records the generated workbook in its history.
         * @summary Import the draft into the catalogue (new dishes and group sets)
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importPptxImport(draftId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileImportReportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importPptxImport(draftId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.importPptxImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dishes whose name matches a catalogue dish exactly are linked to it on save.
         * @summary Save the edited content of an import draft
         * @param {string} draftId 
         * @param {PptxImportContentDto} pptxImportContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePptxImport(draftId: string, pptxImportContentDto: PptxImportContentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PptxImportDraftDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePptxImport(draftId, pptxImportContentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.savePptxImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upload an offer deck (PPTX) and start reading dishes and group sets from it
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPptxImport(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PptxImportSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPptxImport(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPptxImportsApi.uploadPptxImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestPptxImportsApi - factory interface
 */
export const RestPptxImportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestPptxImportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an import draft
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePptxImport(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePptxImport(draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the draft as the import workbook (Dania / Zestawy / Struktura)
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPptxImportWorkbook(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadPptxImportWorkbook(draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read the deck again, replacing the draft content
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractPptxImportAgain(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<PptxImportDraftDto> {
            return localVarFp.extractPptxImportAgain(draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an import draft with its slides and editable content
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPptxImport(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<PptxImportDraftDto> {
            return localVarFp.getPptxImport(draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List catalogue import drafts read from offer decks, newest first
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPptxImports(options?: RawAxiosRequestConfig): AxiosPromise<Array<PptxImportSummaryDto>> {
            return localVarFp.getPptxImports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the rendered image of one deck slide
         * @param {string} draftId 
         * @param {number} slideNumber 
         * @param {string} [version] The slide preview version; it only makes the URL unique per rendering, so browsers never reuse an image cached for an older rendering
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPptxSlideImage(draftId: string, slideNumber: number, version?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getPptxSlideImage(draftId, slideNumber, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Slides are rendered in the background after the upload. While that runs the status is RENDERING and the list is empty; a draft uploaded before previews existed starts rendering on the first call. 
         * @summary Get the rendered previews of the deck slides with the position of every text line
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPptxSlidePreviews(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<PptxSlidePreviewsDto> {
            return localVarFp.getPptxSlidePreviews(draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * Runs the same importer as the dish import screen and records the generated workbook in its history.
         * @summary Import the draft into the catalogue (new dishes and group sets)
         * @param {string} draftId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importPptxImport(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileImportReportDto> {
            return localVarFp.importPptxImport(draftId, options).then((request) => request(axios, basePath));
        },
        /**
         * Dishes whose name matches a catalogue dish exactly are linked to it on save.
         * @summary Save the edited content of an import draft
         * @param {string} draftId 
         * @param {PptxImportContentDto} pptxImportContentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePptxImport(draftId: string, pptxImportContentDto: PptxImportContentDto, options?: RawAxiosRequestConfig): AxiosPromise<PptxImportDraftDto> {
            return localVarFp.savePptxImport(draftId, pptxImportContentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload an offer deck (PPTX) and start reading dishes and group sets from it
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPptxImport(file: File, options?: RawAxiosRequestConfig): AxiosPromise<PptxImportSummaryDto> {
            return localVarFp.uploadPptxImport(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestPptxImportsApi - interface
 */
export interface RestPptxImportsApiInterface {
    /**
     * 
     * @summary Delete an import draft
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePptxImport(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Download the draft as the import workbook (Dania / Zestawy / Struktura)
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    downloadPptxImportWorkbook(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Read the deck again, replacing the draft content
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    extractPptxImportAgain(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<PptxImportDraftDto>;

    /**
     * 
     * @summary Get an import draft with its slides and editable content
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPptxImport(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<PptxImportDraftDto>;

    /**
     * 
     * @summary List catalogue import drafts read from offer decks, newest first
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPptxImports(options?: RawAxiosRequestConfig): AxiosPromise<Array<PptxImportSummaryDto>>;

    /**
     * 
     * @summary Get the rendered image of one deck slide
     * @param {string} draftId 
     * @param {number} slideNumber 
     * @param {string} [version] The slide preview version; it only makes the URL unique per rendering, so browsers never reuse an image cached for an older rendering
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPptxSlideImage(draftId: string, slideNumber: number, version?: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Slides are rendered in the background after the upload. While that runs the status is RENDERING and the list is empty; a draft uploaded before previews existed starts rendering on the first call. 
     * @summary Get the rendered previews of the deck slides with the position of every text line
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPptxSlidePreviews(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<PptxSlidePreviewsDto>;

    /**
     * Runs the same importer as the dish import screen and records the generated workbook in its history.
     * @summary Import the draft into the catalogue (new dishes and group sets)
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importPptxImport(draftId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileImportReportDto>;

    /**
     * Dishes whose name matches a catalogue dish exactly are linked to it on save.
     * @summary Save the edited content of an import draft
     * @param {string} draftId 
     * @param {PptxImportContentDto} pptxImportContentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    savePptxImport(draftId: string, pptxImportContentDto: PptxImportContentDto, options?: RawAxiosRequestConfig): AxiosPromise<PptxImportDraftDto>;

    /**
     * 
     * @summary Upload an offer deck (PPTX) and start reading dishes and group sets from it
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadPptxImport(file: File, options?: RawAxiosRequestConfig): AxiosPromise<PptxImportSummaryDto>;

}

/**
 * RestPptxImportsApi - object-oriented interface
 */
export class RestPptxImportsApi extends BaseAPI implements RestPptxImportsApiInterface {
    /**
     * 
     * @summary Delete an import draft
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePptxImport(draftId: string, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).deletePptxImport(draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the draft as the import workbook (Dania / Zestawy / Struktura)
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public downloadPptxImportWorkbook(draftId: string, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).downloadPptxImportWorkbook(draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read the deck again, replacing the draft content
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public extractPptxImportAgain(draftId: string, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).extractPptxImportAgain(draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an import draft with its slides and editable content
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPptxImport(draftId: string, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).getPptxImport(draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List catalogue import drafts read from offer decks, newest first
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPptxImports(options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).getPptxImports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the rendered image of one deck slide
     * @param {string} draftId 
     * @param {number} slideNumber 
     * @param {string} [version] The slide preview version; it only makes the URL unique per rendering, so browsers never reuse an image cached for an older rendering
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPptxSlideImage(draftId: string, slideNumber: number, version?: string, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).getPptxSlideImage(draftId, slideNumber, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Slides are rendered in the background after the upload. While that runs the status is RENDERING and the list is empty; a draft uploaded before previews existed starts rendering on the first call. 
     * @summary Get the rendered previews of the deck slides with the position of every text line
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPptxSlidePreviews(draftId: string, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).getPptxSlidePreviews(draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Runs the same importer as the dish import screen and records the generated workbook in its history.
     * @summary Import the draft into the catalogue (new dishes and group sets)
     * @param {string} draftId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importPptxImport(draftId: string, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).importPptxImport(draftId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dishes whose name matches a catalogue dish exactly are linked to it on save.
     * @summary Save the edited content of an import draft
     * @param {string} draftId 
     * @param {PptxImportContentDto} pptxImportContentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public savePptxImport(draftId: string, pptxImportContentDto: PptxImportContentDto, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).savePptxImport(draftId, pptxImportContentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload an offer deck (PPTX) and start reading dishes and group sets from it
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public uploadPptxImport(file: File, options?: RawAxiosRequestConfig) {
        return RestPptxImportsApiFp(this.configuration).uploadPptxImport(file, options).then((request) => request(this.axios, this.basePath));
    }
}

